/*
    例
    <ul class="loadMoreContents">
        <li></li>
        <li></li>
        <li></li>
        <li class="hidden"></li>
        <li class="hidden"></li>
    </ul>
    <a id="loadMore">もっと見る</a>
*/

$(function () {
    var initNum = 4;
    var lists = ".loadMoreContents";
    var btn = "#loadMore";
    var hideClass = "hidden";

    $(`${lists} li:nth-child(n + ${initNum + 1})`).addClass(hideClass);

    $(btn).on('click', function () {
        $(`${lists} li.${hideClass}`).slice(0).removeClass(hideClass);
        if ($(`${lists} li.${hideClass}`).length == 0) {
            $(btn).fadeOut();
        }
    });
});